import React, { useEffect, useState } from "react";
import EmptyList from "../../ShoppingList/EmptyList";
// import ProfileShoppingListCard from "./ProfileShoppingListCard";

import ListCard from "./ListCard";

const Lists = ({ shoppingListData, loading }) => {
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);
  // Effect to handle window resize
  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };
    window.addEventListener("resize", handleResize);
    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <span
      className="row mx-0"
      style={{ marginTop: isSmallScreen ? "" : "4px" }}
    >
      {!loading && shoppingListData ? (
        shoppingListData?.length > 0 ? (
          shoppingListData?.map((list, index) => {
            return (
              <>
                <ListCard list={list} index={index} />
              </>
            );
          })
        ) : (
          <div style={{ height: "25rem", maxHeight: "25rem" }}>
            <div
              className={`h-100 d-flex justify-content-center align-items-center flex-column px-5`}
              style={{
                minHeight: "10vh", // Make it fill the full viewport height
                height: "25rem",
                maxHeight: "25rem",
                width: "100%",
                gap: "24px",
              }}
            >
              <svg
                style={{ width: "110px", height: "110px" }}
                width="141"
                height="141"
                viewBox="0 0 141 141"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="2"
                  y="2"
                  width="137"
                  height="137"
                  rx="68.5"
                  stroke="#676A79"
                  stroke-width="3"
                />
                <path
                  d="M101.933 51.3335L70.133 83.1333C66.9663 86.3 57.5662 87.7667 55.4662 85.6667C53.3662 83.5667 54.7996 74.1667 57.9662 71L89.7997 39.1667C90.5847 38.3103 91.535 37.6218 92.5937 37.1428C93.652 36.6638 94.7967 36.4041 95.9583 36.3797C97.1197 36.3552 98.2743 36.5664 99.352 37.0004C100.43 37.4344 101.408 38.0824 102.229 38.9051C103.049 39.7278 103.694 40.7081 104.125 41.787C104.556 42.8659 104.765 44.0209 104.737 45.1824C104.709 46.3439 104.446 47.4878 103.965 48.545C103.483 49.6022 102.792 50.5508 101.933 51.3335Z"
                  stroke="#676A79"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M67.6665 43.3333H50.9998C47.4636 43.3333 44.0724 44.7381 41.5719 47.2386C39.0715 49.7391 37.6665 53.1304 37.6665 56.6667V90C37.6665 93.5363 39.0715 96.9277 41.5719 99.428C44.0724 101.929 47.4636 103.333 50.9998 103.333H87.6665C95.0332 103.333 97.6665 97.3333 97.6665 90V73.3333"
                  stroke="#676A79"
                  stroke-width="3"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div
                style={{
                  whiteSpace: "normal",
                  width: "100%",
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "24px",
                  color: "#676A79",
                  textAlign: "center",
                }}
              >
                No Posts Yet
              </div>
            </div>
          </div>
        )
      ) : null}
    </span>
  );
};

export default Lists;
